import _ from 'lodash'

export const SET_ACTIVE_ACCOMMODATION = 'SET_ACTIVE_ACCOMMODATION'
export const RESET_ACTIVE_ACCOMMODATION = 'RESET_ACTIVE_ACCOMMODATION'

export const setActiveAccommodation = (accommodationId) => (
  dispatch,
  getState
) => {
  const accommodations = _.get(getState(), 'accommodationsData.data', [])
  const activeAccommodation = _.find(accommodations, (accommodation) => {
    return accommodation?.id === accommodationId
  })
  if (activeAccommodation) {
    dispatch({ type: SET_ACTIVE_ACCOMMODATION, payload: activeAccommodation })
  }
}

export const resetActiveAccommodation = () => (dispatch) => {
  dispatch({ type: RESET_ACTIVE_ACCOMMODATION })
}
